import React from 'react';
import { FormNumber, Fieldset } from '~/components/FormControl';
import { Form, Col } from 'react-bootstrap';

function HealthPoint() {
    return (
        <Col sm={6}>
            <Fieldset>
                <Fieldset.Legend>HP:</Fieldset.Legend>
                <Form.Row>
                    <FormNumber
                        name={'hpHealed'}
                        sm={3}
                    />
                    <FormNumber
                        name={'hpLost'}
                        sm={3}
                        className={'offset-sm-1'}
                    />
                    <FormNumber
                        name={'hpCondition'}
                        sm={3}
                        className={'offset-sm-1'}
                    />
                </Form.Row>
            </Fieldset>
        </Col>
    );
}

export default HealthPoint;
